import { api } from "@/http/api-client"
import type { TListMembersResponse } from "./types"

export function listMembers(slug: string) {
  return api.get<TListMembersResponse>(`/organizations/${slug}/members`)
}
